class FostrElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.fostrLog = (message) => {
      return message
    }

    if (document.querySelector('fostr-element').dataset.fostrLogs === 'true') {
      window.fostrLog = (message, data) => {
        console.log(`%c${message}`, 'color: #FFF; font-size: 14px; background: #000000; padding: 1rem;')
        if (data) console.log(data)
      }
    }

    window.capitalize = str => str[0].toUpperCase() + str.substring(1)

    window.titleize = str => {
      let newStr = ''

      str.toLowerCase()
          .replaceAll(/[()]/g, '')
          .split('-')
          .forEach((word, i) => newStr = newStr + (i === 0 ? '' : ' ') + window.capitalize(word))

      return newStr
    }

    window.handleize = str => {
      str = str.trim() // remove whitespace from string
      str = str.toLowerCase() // Set to lowercase
      str = str.replace(/\s+/g, '-') // Replace spaces
      str = str.replace(/&/g, '-') // Replace ampersands
      str = str.replace(/----/g, '-') // Replace four dashes
      str = str.replace(/---/g, '-') // Replace triple dashes
      str = str.replace(/--/g, '-') // Replace double dashes
      str = str.replace(/"/g, '') // Removed double quotes
      return str;
    }

    window.getPageSource = () => {
      let source = ''
      switch (true) {
        case window.location.pathname === '/':
          source = 'homepage'
          break
        case window.location.pathname.indexOf('/wishlist') > -1:
          source = 'wishlist'
          break
        case window.location.pathname.indexOf('/account/') > -1:
          source = 'account'
          break
        case window.location.pathname.indexOf('/search/') > -1:
          source = 'plp search'
          break
        case window.location.pathname.indexOf('/products/') > -1:
          source = 'pdp'
          break
        case window.location.pathname.indexOf('/collections/') > -1:
          source = 'plp'
          break
        case window.location.pathname.indexOf('/pages/') > -1:
          source = 'page'
          break
        case window.location.pathname.indexOf('/blogs/') > -1:
          source = 'blog'
          break
        default:
          source = 'other'
      }

      return source
    }

    window.fostrFetch = payload => {
      return fetch(`https://${window.Shopify.shop}/api/${window.API_VERSION}/graphql.json`, {
        priority: "low",
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": window.API_ACCESS
        },
        body: payload
      })
    }
  }
}

customElements.define('fostr-element', FostrElement);
